import { render, staticRenderFns } from "./SubscriptionMain.vue?vue&type=template&id=b23f29f8&scoped=true"
import script from "./SubscriptionMain.vue?vue&type=script&lang=js"
export * from "./SubscriptionMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23f29f8",
  null
  
)

export default component.exports